import * as actionTypes from "../ActionTypes";

const initialState = {
  loading: false,
  videos: [],
  error: null,
  success: false,
};

const videoResourcesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_VIDEO_REQUEST:
    case actionTypes.UPDATE_VIDEO_REQUEST:
    case actionTypes.DELETE_VIDEO_REQUEST:
    case actionTypes.READ_VIDEO_REQUEST:
      return { ...state, loading: true, success: false, error: null };

    case actionTypes.SAVE_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        videos: [...state.videos, action.payload],
      };

    case actionTypes.UPDATE_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        videos: state.videos.map((item) =>
          item._id === action.payload._id ? action.payload : item
        ),
      };

    case actionTypes.DELETE_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        videos: state.videos.filter((item) => item._id !== action.payload._id),
      };

    case actionTypes.READ_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        videos: action.payload,
      };

    case actionTypes.SAVE_VIDEO_FAILURE:
    case actionTypes.UPDATE_VIDEO_FAILURE:
    case actionTypes.DELETE_VIDEO_FAILURE:
    case actionTypes.READ_VIDEO_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };

    default:
      return state;
  }
};

export default videoResourcesReducer;
